import { clsx, type ClassValue } from "clsx";

/**
 * Utility for composing CSS class names conditionally.
 * Uses clsx to merge class values (strings, arrays, objects).
 * @param inputs - Class values to combine
 * @returns Combined class string
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
